import { SectionTypeModel } from '@app/models/SectionTypeModel';
import { SectionTypeRepository } from '@app/repositories/SectionTypeRepository';
import { ServiceBase } from '@app/services/ServiceBase';

export class SectionTypeService extends ServiceBase<SectionTypeModel, SectionTypeRepository<SectionTypeModel>> {
    public constructor() {
        super(new SectionTypeRepository());
    }
}
